<template>
  <el-dialog
    title="唛头查看及打印"
    :visible="isShow"
    custom-class="temp-style"
    width="80%"
    :before-close="handleClose"
  >
    <el-main
      v-if="isLoading"
      v-loading="isLoading"
    />
    <template v-else>
      <el-row>
        <h4>基础信息</h4>
        <el-form
          v-if="baseMessageList.length"
          ref="formData"
          :inline="false"
          :model="formData"
        >
          <el-col
            v-for="(item, index) in baseMessageList"
            :key="index"
            :span="item.colSpan"
          >
            <el-form-item
              :label="item.title + ':'"
              :prop="item.title"
              label-width="110px"
            >
              <p>
                {{ item.value }}
              </p>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>

      <div class="file-style flex product-style">
        <h4>回执附件</h4>
        <ul v-if="fileList.length">
          <li
            v-for="(item, index) in fileList"
            :key="index"
            @click="handleFileDown(item)"
          >
            {{ item.fileName }}
          </li>
        </ul>
      </div>

      <div class="flex flex-align product-style">
        <h4>产品信息</h4>
      </div>
      <el-table
        v-if="productHeaderList.length"
        ref="tableDataRef"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column label="序号" align="left" type="index" />
        <el-table-column
          v-for="(item, index) in productHeaderList"
          :key="index"
          :prop="item.key"
          :label="item.title"
          align="left"
          min-width="150"
        >
          <template slot-scope="scope">
            <span v-if="isClientInfo(item)" v-html="scope.row[item.key]" />
            <span v-else>{{ scope.row[item.key] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <p v-else class="empty-data">
        暂无产品信息
      </p>
    </template>

    <div slot="footer" class="dialog-footer">
      <el-button type="default" @click="handleClose">
        关闭
      </el-button>
      <el-button type="primary" @click="handlePrint">
        打印唛头
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { previewMarkInfo, printMarkInfo, attachmentGetToken, getUrlByFileID } from '@/API';

export default {
  data () {
    return {
      isShow: false,
      isLoading: false,
      formData: {},
      baseType: 'markField',
      baseMessageList: [], // 基础信息
      productHeaderList: [], // 产品信息Table头数据
      tableData: [], // 产品信息数据
      token: '',
      downFileUrl: '',
      currentItem: {},
      fileList: [] // 附件列表
    };
  },

  methods: {
    initData (params) {
      this.isLoading = true;
      previewMarkInfo({
        markInfoId: params.id || ''
      }).then(res => {
        this.isLoading = false;
        const { data, status } = res.data;
        if (status === '200') {
          this.baseMessageList = (data.markBaseInfo || []).map(item => {
            return {
              ...item,
              colSpan: ['remark'].indexOf(item.fieldKey) > -1 ? 24 : 8
            };
          });
          this.fileList = data.acknowledgementOfReceipt || [];
          this.productHeaderList = data.productList.column || [];
          this.tableData = data.productList.value || [];
          this.isLoading = false;
        } else {
          this.isShow = false;
        }
      }).catch(e => {
        this.isLoading = false;
      });
    },

    // 附件下载
    handleFileDown (item) {
      window.open(this.downFileUrl + `/${item.fileToken}?Token=${this.token}`, '_blank');
    },

    // 处理确认打印
    handlePrint () {
      // 获取文件信息
      printMarkInfo({
        markInfoId: this.currentItem.id,
        partialId: this.currentItem.partialId
      }).then(res => {
        const { data, status } = res.data;
        if (status === '200') {
          // 获取文件服务器地址链接，进行预览
          getUrlByFileID(data.fileToken).then(res => {
            const { data, status } = res.data;
            if (status === '200') {
              window.open(data);
            }
          });
        }
      });
    },

    openDialog (params) {
      this.currentItem = params;
      this.initData(params);
      this.initToken();
      this.isShow = true;
    },

    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch((err) => {
        console.log(err);
      });
    },

    isClientInfo (val) {
      return val.key === 'customerInfo';
    },

    handleClose () {
      this.isShow = false;
      this.formData = {};
      this.currentItem = {};
      this.baseMessageList = [];
      this.productHeaderList = [];
      this.tableData = [];
    }
  }
};
</script>

<style lang="scss">
.temp-style {
  .el-dialog__body {
    padding: 20px !important;
  }
  .el-main {
    min-height: 300px !important;
  }
}
</style>

<style lang="scss" scoped>
.temp-style {
  .flex {
    display: flex;
  }
  .flex-align {
    align-items: center;
  }
  .flex-1 {
    flex: 1;
  }
  .el-col {
    height: 40px;
  }
  h4 {
    margin: 10px 0;
  }
  .product-style {
    margin: 12px 0;
    .btn-style {
      margin-left: 20px;
    }
  }
  .file-style {
    justify-content: start;
    ul {
      list-style: none;
      margin-top: 10px;
      margin-left: 10px;
      li {
        color: #3F9EF5;
        line-height: 22px;
        cursor: pointer;
      }
    }
  }
  .empty-data {
    text-align: center;
    &.file{
      margin-top: 10px;
    }
  }
}
</style>
